import script from "./LestextesDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./LestextesDetails.vue?vue&type=script&setup=true&lang=ts"

import "./LestextesDetails.vue?vue&type=style&index=0&id=f52c00b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f52c00b0"]])

export default __exports__